"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePremium = void 0;
const common_1 = require("../../../../../common");
const common_2 = require("../../../../common");
const face_amount_calculator_1 = require("./face-amount-calculator");
function calculatePremiumFromFaceAmount(options, faceAmount, premiumFactor) {
    const paymentMethodFactor = common_1.getBillingFactor(options);
    const paymentPeriodMultiplier = common_1.getPaymentPeriodFactor(options.paymentPeriod);
    const amount = faceAmount * premiumFactor * paymentMethodFactor * paymentPeriodMultiplier;
    return common_2.roundPayment(amount);
}
function calculatePremium(options, rate, faceFactor, premiumFactor) {
    const faceAmount = face_amount_calculator_1.calculateFaceAmount(options, rate, faceFactor);
    return calculatePremiumFromFaceAmount(options, faceAmount, premiumFactor);
}
exports.calculatePremium = calculatePremium;
//# sourceMappingURL=premium-calculator.js.map